<div class="map-control save-controls">
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
    <button mat-flat-button class="cancel-button" (click)="cancel()">Cancel</button>
    <button mat-flat-button color="primary" class="mat-elevation-z0" (click)="save()">Save
    </button>
  </div>
</div>
